import useSWRImmutable from 'swr/immutable'
import { endpoints, request } from '.'

export const useProductDetails = () => {
  const { data, isLoading, isValidating, error } = useSWRImmutable(
    endpoints.dataAccount.get(),
    request,
  )
  return {
    data: data?.data?.data?.attributes?.productDetails,
    isLoading,
    isValidating,
    error,
  }
}
